module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('d-modal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "print-all-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "print-calendars__header border-1-bottom text-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.print_latest_version')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "print-all-modal__body"
  }, [_c('div', {
    attrs: {
      "id": "printTaskOverviews"
    }
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.sortedUsers.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.no_saved_versions')))]) : _vm._e()], _vm._v(" "), _vm._l((_vm.sortedUsers), function(user) {
    return _c('TaskOverviewUser', {
      key: user.id,
      attrs: {
        "user": user.user,
        "version": user.version,
        "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
        "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold
      }
    })
  })], 2)]), _vm._v(" "), (_vm.isShowOptionsModal) ? _c('d-modal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "d-modal__content d-modal__content__hide-task-hours",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsHideTaskHoursUnderThreshold.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label marg-1-right"
  }, [_vm._v("Skjul timepuljer på opgaver under " + _vm._s(_vm.schoolThresholdToHideTaskHours) + "\n            timer")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isHideTaskHoursUnderThreshold
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-modal__print_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')))])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36534b01!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Print/PrintTaskOverviews.vue
// module id = 1527
// module chunks = 1